import React, { useState } from 'react';
import { ArrowLeft, Download, Calendar, Heart, Activity, Users, TrendingUp, TrendingDown, AlertCircle, CheckCircle, Clock } from 'lucide-react';
import { StarField } from '../components/Background/StarField';
export function GrowthPage() {
  const [timeRange, setTimeRange] = useState('week');
  const [selectedGrade, setSelectedGrade] = useState<'all' | 'grade7' | 'grade8' | 'grade9'>('all');
  // 模拟数据 - 基于原型图
  const data = {
    // 最新测评任务分析
    latestAssessment: {
      name: '2025-2026学年第一学期学生心理健康普查',
      period: '2025.09.01-2025.09.30',
      completionRate: 100,
      onTimeRate: 96,
      totalParticipants: 3086,
      completedCount: 2987,
      uncompletedCount: 36,
      completionRatio: 89,
      uncompletionRatio: 2.5
    },
    // 心理状况实时分布
    mentalStatusDistribution: {
      latest: [{
        level: '一级关注',
        percentage: 9.1,
        count: 281,
        color: '#EF4444'
      }, {
        level: '二级关注',
        percentage: 39.4,
        count: 1216,
        color: '#F59E0B'
      }, {
        level: '三级关注',
        percentage: 138.14,
        count: 4264,
        color: '#FCD34D'
      }, {
        level: '四级关注',
        percentage: 264.26,
        count: 8156,
        color: '#A78BFA'
      }, {
        level: '良好',
        percentage: 544.55,
        count: 16810,
        color: '#22C55E'
      }],
      interview: [{
        level: '一级关注',
        percentage: 3.0,
        count: 93,
        color: '#EF4444'
      }, {
        level: '二级关注',
        percentage: 20.2,
        count: 624,
        color: '#F59E0B'
      }, {
        level: '三级关注',
        percentage: 143.14,
        count: 4421,
        color: '#FCD34D'
      }, {
        level: '四级关注',
        percentage: 264.27,
        count: 8159,
        color: '#A78BFA'
      }, {
        level: '良好',
        percentage: 564.57,
        count: 17430,
        color: '#22C55E'
      }]
    },
    // 心理状况变化监测（时间序列）
    mentalStatusTrend: [{
      date: '2025/7/1',
      level1: 10,
      level2: 15,
      level3: 20,
      level4: 25,
      good: 90
    }, {
      date: '2025/7/4',
      level1: 8,
      level2: 12,
      level3: 18,
      level4: 22,
      good: 92
    }, {
      date: '2025/7/7',
      level1: 12,
      level2: 18,
      level3: 22,
      level4: 28,
      good: 88
    }, {
      date: '2025/7/10',
      level1: 6,
      level2: 10,
      level3: 15,
      level4: 20,
      good: 94
    }, {
      date: '2025/7/13',
      level1: 9,
      level2: 14,
      level3: 19,
      level4: 24,
      good: 91
    }, {
      date: '2025/7/16',
      level1: 7,
      level2: 11,
      level3: 16,
      level4: 21,
      good: 93
    }, {
      date: '2025/7/19',
      level1: 11,
      level2: 16,
      level3: 21,
      level4: 26,
      good: 89
    }, {
      date: '2025/7/22',
      level1: 5,
      level2: 9,
      level3: 14,
      level4: 19,
      good: 95
    }, {
      date: '2025/7/25',
      level1: 8,
      level2: 13,
      level3: 18,
      level4: 23,
      good: 92
    }, {
      date: '2025/7/28',
      level1: 10,
      level2: 15,
      level3: 20,
      level4: 25,
      good: 90
    }, {
      date: '2025/7/31',
      level1: 7,
      level2: 12,
      level3: 17,
      level4: 22,
      good: 93
    }],
    // 症状概况（雷达图数据）
    symptomOverview: [{
      symptom: '抑郁',
      score: 35
    }, {
      symptom: '强迫',
      score: 28
    }, {
      symptom: '焦虑',
      score: 42
    }, {
      symptom: '失眠',
      score: 38
    }, {
      symptom: '人际敏感',
      score: 32
    }, {
      symptom: '敌对',
      score: 25
    }],
    // 症状排名
    symptomRanking: [{
      rank: 1,
      symptom: '焦虑',
      severity: 35,
      count: 35,
      schoolRatio: 12.0
    }, {
      rank: 2,
      symptom: '强迫',
      severity: 26,
      count: 26,
      schoolRatio: 9.0
    }, {
      rank: 3,
      symptom: '失眠',
      severity: 80,
      count: 80,
      schoolRatio: 25.0
    }, {
      rank: 4,
      symptom: '抑郁',
      severity: 42,
      count: 42,
      schoolRatio: 18.0
    }, {
      rank: 5,
      symptom: '人际敏感',
      severity: 85,
      count: 85,
      schoolRatio: 25.3
    }, {
      rank: 6,
      symptom: '敌对',
      severity: 7,
      count: 7,
      schoolRatio: 6.7
    }, {
      rank: 7,
      symptom: '躯体',
      severity: 3,
      count: 3,
      schoolRatio: 4.0
    }],
    // 需关注学生情况
    studentsNeedingAttention: {
      level1: 3,
      level2: 20,
      other: 5
    },
    // 各年级分布情况
    gradeDistribution: [{
      grade: '七年级',
      level1: 2,
      level2: 4,
      other: 6,
      total: 12
    }, {
      grade: '八年级',
      level1: 4,
      level2: 6,
      other: 8,
      total: 18
    }, {
      grade: '九年级',
      level1: 1,
      level2: 3,
      other: 5,
      total: 9
    }, {
      grade: '高一',
      level1: 3,
      level2: 5,
      other: 7,
      total: 15
    }, {
      grade: '高二',
      level1: 2,
      level2: 4,
      other: 6,
      total: 12
    }, {
      grade: '高三',
      level1: 1,
      level2: 2,
      other: 4,
      total: 7
    }],
    // 心理干预策略统计
    interventionStats: [{
      category: '轻度干预',
      percentage: 92,
      color: '#22C55E'
    }, {
      category: '中度干预',
      percentage: 5,
      color: '#F59E0B'
    }, {
      category: '重度干预',
      percentage: 3,
      color: '#EF4444'
    }]
  };
  return <div className="relative w-full min-h-screen bg-[#0B1120] overflow-auto" data-id="element-847">
      {/* Background */}
      <StarField data-id="element-848" />

      {/* Header */}
      <header className="sticky top-0 z-50 bg-gradient-to-b from-[#0B1120] to-[#0B1120]/95 backdrop-blur-sm border-b border-[#F472B6]/20" data-id="element-849">
        <div className="px-8 py-4" data-id="element-850">
          <div className="flex items-center justify-between" data-id="element-851">
            {/* Left: Back & Title */}
            <div className="flex items-center gap-6" data-id="element-852">
              <button onClick={() => window.history.back()} className="p-2 glass-panel rounded-lg hover:bg-white/10 transition-colors" data-id="element-853">
                <ArrowLeft className="w-5 h-5 text-gray-400" data-id="element-854" />
              </button>
              <div data-id="element-855">
                <h1 className="text-2xl font-bold text-white flex items-center gap-3" data-id="element-856">
                  <div className="w-10 h-10 rounded-xl bg-[#F472B6]/20 flex items-center justify-center border border-[#F472B6]/30" data-id="element-857">
                    <Heart className="w-6 h-6 text-[#F472B6]" data-id="element-858" />
                  </div>
                  易教·关爱 成长关怀
                </h1>
                <p className="text-sm text-gray-400 mt-1" data-id="element-859">
                  全程陪伴 · 精准识别 · 温暖守护
                </p>
              </div>
            </div>

            {/* Right: Actions */}
            <div className="flex items-center gap-4" data-id="element-860">
              <div className="flex items-center gap-2 glass-panel px-3 py-2 rounded-lg border border-white/10" data-id="element-861">
                <Calendar className="w-4 h-4 text-gray-400" data-id="element-862" />
                <select value={timeRange} onChange={e => setTimeRange(e.target.value)} className="bg-transparent text-white text-sm focus:outline-none" data-id="element-863">
                  <option value="week" data-id="element-864">本周</option>
                  <option value="month" data-id="element-865">本月</option>
                  <option value="semester" data-id="element-866">本学期</option>
                </select>
              </div>
              <button className="flex items-center gap-2 glass-panel px-4 py-2 rounded-lg hover:bg-white/10 transition-colors border border-white/10" data-id="element-867">
                <Download className="w-4 h-4 text-gray-400" data-id="element-868" />
                <span className="text-white text-sm" data-id="element-869">导出报告</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-8 py-6" data-id="element-870">
        {/* Latest Assessment Task */}
        <div className="glass-panel p-6 rounded-xl border border-white/10 mb-6" data-id="element-871">
          <div className="flex items-center justify-between mb-4" data-id="element-872">
            <h3 className="text-white font-bold flex items-center gap-2" data-id="element-873">
              <Clock className="w-5 h-5 text-[#F472B6]" data-id="element-874" />
              最新测评任务分析
            </h3>
            <button className="text-[#F472B6] text-sm hover:underline" data-id="element-875">
              更多 &gt;&gt;
            </button>
          </div>
          <div className="grid grid-cols-12 gap-6" data-id="element-876">
            <div className="col-span-8" data-id="element-877">
              <h4 className="text-white font-medium mb-2" data-id="element-878">
                {data.latestAssessment.name}
              </h4>
              <p className="text-gray-400 text-sm mb-4" data-id="element-879">
                {data.latestAssessment.period}
              </p>
              <div className="grid grid-cols-2 gap-4" data-id="element-880">
                <div className="glass-panel p-4 rounded-lg border border-[#F472B6]/20" data-id="element-881">
                  <div className="text-sm text-gray-400 mb-1" data-id="element-882">测评进度</div>
                  <div className="text-2xl font-bold text-[#F472B6] mb-2" data-id="element-883">
                    {data.latestAssessment.completionRate}%
                  </div>
                  <div className="flex items-center gap-2" data-id="element-884">
                    <button className="px-3 py-1 bg-white/5 rounded text-xs text-white hover:bg-white/10" data-id="element-885">
                      任务详情
                    </button>
                    <button className="px-3 py-1 bg-[#F472B6]/20 rounded text-xs text-[#F472B6] hover:bg-[#F472B6]/30" data-id="element-886">
                      查看报告
                    </button>
                  </div>
                </div>
                <div className="glass-panel p-4 rounded-lg border border-white/10" data-id="element-887">
                  <div className="text-sm text-gray-400 mb-1" data-id="element-888">
                    班主任任务完成进度
                  </div>
                  <div className="text-2xl font-bold text-white mb-2" data-id="element-889">
                    {data.latestAssessment.onTimeRate}%
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-4" data-id="element-890">
              <div className="glass-panel p-4 rounded-lg border border-white/10 h-full" data-id="element-891">
                <div className="relative w-32 h-32 mx-auto" data-id="element-892">
                  <svg viewBox="0 0 100 100" className="transform -rotate-90" data-id="element-893">
                    <circle cx="50" cy="50" r="40" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="8" data-id="element-894" />
                    <circle cx="50" cy="50" r="40" fill="none" stroke="#22C55E" strokeWidth="8" strokeDasharray={`${data.latestAssessment.completionRatio / 100 * 251.2} 251.2`} strokeLinecap="round" data-id="element-895" />
                  </svg>
                  <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-896">
                    <div className="text-2xl font-bold text-white" data-id="element-897">
                      {data.latestAssessment.completionRatio}%
                    </div>
                    <div className="text-xs text-gray-400" data-id="element-898">完成占比</div>
                  </div>
                </div>
                <div className="mt-4 space-y-2 text-sm" data-id="element-899">
                  <div className="flex items-center justify-between" data-id="element-900">
                    <span className="text-gray-400" data-id="element-901">分发总人数</span>
                    <span className="text-white font-bold" data-id="element-902">
                      {data.latestAssessment.totalParticipants}
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-903">
                    <span className="text-gray-400" data-id="element-904">测评完成人数</span>
                    <span className="text-green-400 font-bold" data-id="element-905">
                      {data.latestAssessment.completedCount}
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-906">
                    <span className="text-gray-400" data-id="element-907">无效人数</span>
                    <span className="text-orange-400 font-bold" data-id="element-908">
                      {data.latestAssessment.uncompletedCount}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Grid Layout */}
        <div className="grid grid-cols-12 gap-6" data-id="element-909">
          {/* Left Column - Mental Status Distribution */}
          <div className="col-span-4 space-y-6" data-id="element-910">
            {/* Mental Status Real-time Distribution */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-911">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-912">
                <Activity className="w-5 h-5 text-[#F472B6]" data-id="element-913" />
                心理状况实时分布
              </h3>
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-914">
                <div data-id="element-915">
                  <h4 className="text-xs text-gray-400 mb-3 text-center" data-id="element-916">
                    最新测评结果
                  </h4>
                  <div className="relative w-40 h-40 mx-auto" data-id="element-917">
                    <svg viewBox="0 0 200 200" className="transform -rotate-90" data-id="element-918">
                      {data.mentalStatusDistribution.latest.map((item, index, arr) => {
                      const total = arr.reduce((sum, i) => sum + i.count, 0);
                      const startAngle = arr.slice(0, index).reduce((sum, i) => sum + i.count / total * 360, 0);
                      const angle = item.count / total * 360;
                      const startRad = startAngle * Math.PI / 180;
                      const endRad = (startAngle + angle) * Math.PI / 180;
                      const largeArc = angle > 180 ? 1 : 0;
                      const x1 = 100 + 80 * Math.cos(startRad);
                      const y1 = 100 + 80 * Math.sin(startRad);
                      const x2 = 100 + 80 * Math.cos(endRad);
                      const y2 = 100 + 80 * Math.sin(endRad);
                      return <path key={index} d={`M 100 100 L ${x1} ${y1} A 80 80 0 ${largeArc} 1 ${x2} ${y2} Z`} fill={item.color} opacity="0.8" data-id="element-919" />;
                    })}
                      <circle cx="100" cy="100" r="50" fill="#0B1120" data-id="element-920" />
                    </svg>
                  </div>
                </div>
                <div data-id="element-921">
                  <h4 className="text-xs text-gray-400 mb-3 text-center" data-id="element-922">
                    纳入访谈数量
                  </h4>
                  <div className="relative w-40 h-40 mx-auto" data-id="element-923">
                    <svg viewBox="0 0 200 200" className="transform -rotate-90" data-id="element-924">
                      {data.mentalStatusDistribution.interview.map((item, index, arr) => {
                      const total = arr.reduce((sum, i) => sum + i.count, 0);
                      const startAngle = arr.slice(0, index).reduce((sum, i) => sum + i.count / total * 360, 0);
                      const angle = item.count / total * 360;
                      const startRad = startAngle * Math.PI / 180;
                      const endRad = (startAngle + angle) * Math.PI / 180;
                      const largeArc = angle > 180 ? 1 : 0;
                      const x1 = 100 + 80 * Math.cos(startRad);
                      const y1 = 100 + 80 * Math.sin(startRad);
                      const x2 = 100 + 80 * Math.cos(endRad);
                      const y2 = 100 + 80 * Math.sin(endRad);
                      return <path key={index} d={`M 100 100 L ${x1} ${y1} A 80 80 0 ${largeArc} 1 ${x2} ${y2} Z`} fill={item.color} opacity="0.8" data-id="element-925" />;
                    })}
                      <circle cx="100" cy="100" r="50" fill="#0B1120" data-id="element-926" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="space-y-2" data-id="element-927">
                {data.mentalStatusDistribution.latest.map((item, index) => <div key={index} className="flex items-center justify-between text-xs" data-id="element-928">
                    <div className="flex items-center gap-2" data-id="element-929">
                      <div className="w-3 h-3 rounded-full" style={{
                    backgroundColor: item.color
                  }} data-id="element-930"></div>
                      <span className="text-gray-300" data-id="element-931">{item.level}</span>
                    </div>
                    <span className="text-white font-bold" data-id="element-932">
                      {item.percentage}%
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Students Needing Attention */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-933">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-934">
                <AlertCircle className="w-5 h-5 text-[#F472B6]" data-id="element-935" />
                需关注学生情况
              </h3>
              <div className="grid grid-cols-3 gap-3" data-id="element-936">
                <div className="text-center p-4 bg-red-500/10 rounded-lg border border-red-500/30" data-id="element-937">
                  <div className="text-3xl font-bold text-red-400 mb-1" data-id="element-938">
                    {data.studentsNeedingAttention.level1}
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-939">一级关注学生</div>
                  <TrendingDown className="w-4 h-4 text-green-400 mx-auto mt-2" data-id="element-940" />
                </div>
                <div className="text-center p-4 bg-orange-500/10 rounded-lg border border-orange-500/30" data-id="element-941">
                  <div className="text-3xl font-bold text-orange-400 mb-1" data-id="element-942">
                    {data.studentsNeedingAttention.level2}
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-943">二级关注学生</div>
                  <TrendingUp className="w-4 h-4 text-orange-400 mx-auto mt-2" data-id="element-944" />
                </div>
                <div className="text-center p-4 bg-blue-500/10 rounded-lg border border-blue-500/30" data-id="element-945">
                  <div className="text-3xl font-bold text-blue-400 mb-1" data-id="element-946">
                    {data.studentsNeedingAttention.other}
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-947">其他</div>
                </div>
              </div>
            </div>

            {/* Intervention Stats */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-948">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-949">
                <CheckCircle className="w-5 h-5 text-[#F472B6]" data-id="element-950" />
                心理干预策略统计
              </h3>
              <div className="relative w-48 h-48 mx-auto mb-4" data-id="element-951">
                <svg viewBox="0 0 200 200" className="transform -rotate-90" data-id="element-952">
                  {data.interventionStats.map((item, index, arr) => {
                  const total = arr.reduce((sum, i) => sum + i.percentage, 0);
                  const startAngle = arr.slice(0, index).reduce((sum, i) => sum + i.percentage / total * 360, 0);
                  const angle = item.percentage / total * 360;
                  const startRad = startAngle * Math.PI / 180;
                  const endRad = (startAngle + angle) * Math.PI / 180;
                  const largeArc = angle > 180 ? 1 : 0;
                  const x1 = 100 + 80 * Math.cos(startRad);
                  const y1 = 100 + 80 * Math.sin(startRad);
                  const x2 = 100 + 80 * Math.cos(endRad);
                  const y2 = 100 + 80 * Math.sin(endRad);
                  return <path key={index} d={`M 100 100 L ${x1} ${y1} A 80 80 0 ${largeArc} 1 ${x2} ${y2} Z`} fill={item.color} opacity="0.8" data-id="element-953" />;
                })}
                  <circle cx="100" cy="100" r="50" fill="#0B1120" data-id="element-954" />
                </svg>
              </div>
              <div className="space-y-2" data-id="element-955">
                {data.interventionStats.map((item, index) => <div key={index} className="flex items-center justify-between text-sm" data-id="element-956">
                    <div className="flex items-center gap-2" data-id="element-957">
                      <div className="w-3 h-3 rounded-full" style={{
                    backgroundColor: item.color
                  }} data-id="element-958"></div>
                      <span className="text-gray-300" data-id="element-959">{item.category}</span>
                    </div>
                    <span className="text-white font-bold" data-id="element-960">
                      {item.percentage}%
                    </span>
                  </div>)}
              </div>
            </div>
          </div>

          {/* Center Column - Trends & Symptom Overview */}
          <div className="col-span-5 space-y-6" data-id="element-961">
            {/* Mental Status Trend */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-962">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-963">
                <Activity className="w-5 h-5 text-[#F472B6]" data-id="element-964" />
                心理状况变化监测
              </h3>
              <div className="mb-4" data-id="element-965">
                <button className="px-3 py-1 bg-[#F472B6]/20 text-[#F472B6] rounded text-sm" data-id="element-966">
                  最近30天
                </button>
              </div>
              <div className="h-64 relative" data-id="element-967">
                {/* Stacked Area Chart Placeholder */}
                <div className="absolute inset-0 flex items-end justify-between gap-1" data-id="element-968">
                  {data.mentalStatusTrend.map((item, index) => <div key={index} className="flex-1 flex flex-col justify-end h-full" data-id="element-969">
                      <div className="w-full bg-gradient-to-t from-green-500/80 to-green-500/40" style={{
                    height: `${item.good}%`
                  }} data-id="element-970"></div>
                      <div className="w-full bg-gradient-to-t from-purple-500/80 to-purple-500/40" style={{
                    height: `${item.level4}%`
                  }} data-id="element-971"></div>
                      <div className="w-full bg-gradient-to-t from-yellow-500/80 to-yellow-500/40" style={{
                    height: `${item.level3}%`
                  }} data-id="element-972"></div>
                      <div className="w-full bg-gradient-to-t from-orange-500/80 to-orange-500/40" style={{
                    height: `${item.level2}%`
                  }} data-id="element-973"></div>
                      <div className="w-full bg-gradient-to-t from-red-500/80 to-red-500/40" style={{
                    height: `${item.level1}%`
                  }} data-id="element-974"></div>
                    </div>)}
                </div>
              </div>
              <div className="flex items-center justify-center gap-4 mt-4 text-xs" data-id="element-975">
                <div className="flex items-center gap-1" data-id="element-976">
                  <div className="w-3 h-3 bg-red-500 rounded-full" data-id="element-977"></div>
                  <span className="text-gray-400" data-id="element-978">一级关注</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-979">
                  <div className="w-3 h-3 bg-orange-500 rounded-full" data-id="element-980"></div>
                  <span className="text-gray-400" data-id="element-981">二级关注</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-982">
                  <div className="w-3 h-3 bg-yellow-500 rounded-full" data-id="element-983"></div>
                  <span className="text-gray-400" data-id="element-984">三级关注</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-985">
                  <div className="w-3 h-3 bg-purple-500 rounded-full" data-id="element-986"></div>
                  <span className="text-gray-400" data-id="element-987">四级关注</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-988">
                  <div className="w-3 h-3 bg-green-500 rounded-full" data-id="element-989"></div>
                  <span className="text-gray-400" data-id="element-990">良好</span>
                </div>
              </div>
            </div>

            {/* Symptom Overview - Radar Chart */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-991">
              <div className="flex items-center justify-between mb-4" data-id="element-992">
                <h3 className="text-white font-bold flex items-center gap-2" data-id="element-993">
                  <Activity className="w-5 h-5 text-[#F472B6]" data-id="element-994" />
                  症状概况
                </h3>
                <div className="flex gap-2" data-id="element-995">
                  <button className="px-3 py-1 bg-white/5 text-white rounded text-xs" data-id="element-996">
                    抑郁
                  </button>
                  <button className="px-3 py-1 bg-white/5 text-white rounded text-xs" data-id="element-997">
                    压力概况
                  </button>
                  <button className="px-3 py-1 bg-white/5 text-white rounded text-xs" data-id="element-998">
                    韧性概况
                  </button>
                </div>
              </div>
              <div className="relative w-64 h-64 mx-auto" data-id="element-999">
                {/* Radar Chart */}
                <svg viewBox="0 0 200 200" className="w-full h-full" data-id="element-1000">
                  {/* Background hexagon */}
                  <polygon points="100,20 173,60 173,140 100,180 27,140 27,60" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="1" data-id="element-1001" />
                  <polygon points="100,50 153,75 153,125 100,150 47,125 47,75" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="1" data-id="element-1002" />

                  {/* Data polygon */}
                  {(() => {
                  const points = data.symptomOverview.map((item, index) => {
                    const angle = (index * 60 - 90) * (Math.PI / 180);
                    const radius = item.score / 50 * 80;
                    const x = 100 + radius * Math.cos(angle);
                    const y = 100 + radius * Math.sin(angle);
                    return `${x},${y}`;
                  }).join(' ');
                  return <polygon points={points} fill="#F472B6" fillOpacity="0.3" stroke="#F472B6" strokeWidth="2" data-id="element-1003" />;
                })()}

                  {/* Labels */}
                  {data.symptomOverview.map((item, index) => {
                  const angle = (index * 60 - 90) * (Math.PI / 180);
                  const x = 100 + 95 * Math.cos(angle);
                  const y = 100 + 95 * Math.sin(angle);
                  return <text key={index} x={x} y={y} textAnchor="middle" fill="#F472B6" fontSize="12" data-id="element-1004">
                        {item.symptom}
                      </text>;
                })}
                </svg>
              </div>
            </div>
          </div>

          {/* Right Column - Rankings & Grade Distribution */}
          <div className="col-span-3 space-y-6" data-id="element-1005">
            {/* Symptom Ranking */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-1006">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-1007">
                <Users className="w-5 h-5 text-[#F472B6]" data-id="element-1008" />
                症状排名
              </h3>
              <div className="space-y-2" data-id="element-1009">
                <div className="flex items-center justify-between text-xs text-gray-400 pb-2 border-b border-white/10" data-id="element-1010">
                  <span data-id="element-1011">排名</span>
                  <span data-id="element-1012">症状</span>
                  <span data-id="element-1013">人数</span>
                  <span data-id="element-1014">本校占比</span>
                </div>
                {data.symptomRanking.map(item => <div key={item.rank} className="flex items-center justify-between p-2 bg-white/5 rounded-lg text-sm" data-id="element-1015">
                    <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${item.rank === 1 ? 'bg-red-400/20 text-red-400' : item.rank === 2 ? 'bg-orange-400/20 text-orange-400' : item.rank === 3 ? 'bg-yellow-400/20 text-yellow-400' : 'bg-[#F472B6]/20 text-[#F472B6]'}`} data-id="element-1016">
                      {item.rank}
                    </div>
                    <span className="text-white flex-1 text-center" data-id="element-1017">
                      {item.symptom}
                    </span>
                    <span className="text-[#F472B6] font-bold w-12 text-center" data-id="element-1018">
                      {item.count}
                    </span>
                    <span className="text-gray-400 w-16 text-right" data-id="element-1019">
                      {item.schoolRatio}%
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Grade Distribution */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-1020">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-1021">
                <Users className="w-5 h-5 text-[#F472B6]" data-id="element-1022" />
                各年级分布情况
              </h3>
              <div className="space-y-3" data-id="element-1023">
                {data.gradeDistribution.map((grade, index) => <div key={index} data-id="element-1024">
                    <div className="flex items-center justify-between mb-2" data-id="element-1025">
                      <span className="text-white text-sm" data-id="element-1026">{grade.grade}</span>
                      <span className="text-gray-400 text-xs" data-id="element-1027">
                        {grade.total}人
                      </span>
                    </div>
                    <div className="flex gap-1 h-6" data-id="element-1028">
                      <div className="bg-red-500 rounded-l flex items-center justify-center text-xs text-white font-bold" style={{
                    width: `${grade.level1 / grade.total * 100}%`
                  }} data-id="element-1029">
                        {grade.level1 > 0 && grade.level1}
                      </div>
                      <div className="bg-orange-500 flex items-center justify-center text-xs text-white font-bold" style={{
                    width: `${grade.level2 / grade.total * 100}%`
                  }} data-id="element-1030">
                        {grade.level2 > 0 && grade.level2}
                      </div>
                      <div className="bg-blue-500 rounded-r flex items-center justify-center text-xs text-white font-bold" style={{
                    width: `${grade.other / grade.total * 100}%`
                  }} data-id="element-1031">
                        {grade.other > 0 && grade.other}
                      </div>
                    </div>
                  </div>)}
              </div>
              <div className="flex items-center justify-center gap-4 mt-4 text-xs" data-id="element-1032">
                <div className="flex items-center gap-1" data-id="element-1033">
                  <div className="w-3 h-3 bg-red-500 rounded" data-id="element-1034"></div>
                  <span className="text-gray-400" data-id="element-1035">一级关注</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-1036">
                  <div className="w-3 h-3 bg-orange-500 rounded" data-id="element-1037"></div>
                  <span className="text-gray-400" data-id="element-1038">二级关注</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-1039">
                  <div className="w-3 h-3 bg-blue-500 rounded" data-id="element-1040"></div>
                  <span className="text-gray-400" data-id="element-1041">其他</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}